"use client";

import { Logo } from "@workspace/brand/components/logo";
import Link from "next/link";

export function NavLogo() {
  return (
    <Link href="/" className="text-2xl font-medium">
      <Logo className="h-auto w-16" />
    </Link>
  );
}
